// extracted by mini-css-extract-plugin
export default {"h":"styles_h__GdsEw","p":"styles_p__+2iqU","box":"styles_box__6v0w2"};